import { Constant } from '../const';

class MetaDataModel {
    constructor(serialized) {
        // default values to be set if not passed on class instance
        this.serialized = serialized ?? window.apm.serialized;
    }

    // getter to retrieve the read-only metadata model
    // more info: https://developer.mozilla.org/en-US/docs/Web/JavaScript/Guide/Using_Classes#accessor_fields
    get model() {
        let model = {
            appType: Constant.k.COLLABORATION,
        };
        const {
            branching,
            branchingMap,
            branchingMerging,
            metaData
        } = this.serialized;

        const isBranchingMergingEnabledAndInitialized = branchingMerging?.initialized;
        const isBranch = Array.isArray(branching) && branching.length > 0;
        const isMain = !!branchingMap || (isBranchingMergingEnabledAndInitialized && !isBranch);

        if (isMain) {
            model.appType = Constant.k.MAIN_BRANCH;
        } else if (isBranch) {
            model = {
                ...branching[0],
                appType: Constant.k.BRANCH
            };
        }

        return {
            designMetaData: JSON.stringify(metaData ?? null),
            ...model
        };
    }
}

export default MetaDataModel;
